import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var Currency = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.93 9.731C8.22 9.16 7.352 8.738 7.352 8.48c0-.246.56-.432 1.301-.432 1.567 0 2.513.44 2.97.652l1.944.895 2.271-4.844-1.55-.736a11.004 11.004 0 00-2.999-.913V.5h-5.89v2.906C2.498 4.276.72 6.298.72 8.779c0 3.475 3.42 5.002 6.39 5.943 2.222.728 2.222 1.195 2.222 1.371 0 .431-.7.734-1.7.734-1.192 0-2.466-.305-3.41-.817l-2.043-1.103L0 19.822l1.322.758c.985.57 2.367 1.01 3.859 1.236L5.18 24.5H11.1v-2.982C14.095 20.608 16 18.454 16 15.92c.001-4.186-4.41-5.642-6.07-6.19zm.309 10.618l-.525.13v2.668H6.568v-2.53l-.617-.067c-1.536-.166-2.966-.58-3.924-1.135l-.267-.154 1.085-2.446.703.38c1.142.618 2.667.987 4.083.987 1.877 0 3.087-.819 3.087-2.087 0-1.163-.886-1.908-3.173-2.657-2.688-.852-5.437-2.07-5.437-4.657 0-2.004 1.552-3.574 4.152-4.202l.527-.127V1.855h3.115v2.44l.613.07c1.175.133 2.212.418 3.167.87l.33.156-1.123 2.396-.674-.31c-.545-.254-1.681-.782-3.563-.782-1.982 0-2.688.922-2.688 1.785 0 1.066.755 1.61 3.517 2.534 2.538.837 5.132 2.074 5.13 4.907 0 2.069-1.675 3.765-4.372 4.428z",
    fill: "currentColor"
  }));
});
Currency.displayName = 'Currency';

export { Currency, Currency as default };
